import {useCallback, useState} from "react";
import {Section} from "../grouping/Section";
import {Button, Col, Form, FormCheck, FormControl, FormLabel, Row} from "react-bootstrap";
import {ModalPopUp} from "../grouping/ModalPopUp";
import {useForm} from "../../utilities/formutilities";
import {ModalContentContainer} from "../grouping/ModalContentContainer";
import {CustomEditor} from "../CustomEditor";
import {MEMBER_EMPTY, useMemberMutations, useMembersDetailed} from "../../api/memberapi";
import {DataListView} from "../grouping/DataListView";
import {useProvinces} from "../../api/provinceApi";
import {useSexes} from "../../api/sexApi";
import CSVReader from 'react-csv-reader'
import {useClubs} from "../../api/clubapi";
import {LabelWithInput} from "../grouping/LabelWithInput";
import {ButtonLoading} from "../ButtonLoading";
import {useSectors} from "../../api/sectorsapi";
import {useAuthenticated} from "../../contexts/authenticationcontext";
import {FormSelectList} from "../FormSelectList";
import {useCountryCodes} from "../../api/countrycodeapi";
import {logDOM} from "@testing-library/react";
import {checkCategoryFromDate} from "../../utilities/dateutilities";
import {useCategories} from "../../api/categoriesapi";

export function MemberOption(props) {
    const {title} = props;
    const {membersDetailed} = useMembersDetailed();
    const {sectorControl} = useAuthenticated();
    const membersDetailedSectorControlFiltered = sectorControl === 'ALL' ? membersDetailed
        :
        membersDetailed?.filter(m => m.sector === sectorControl);
    const [fileEditing, setFileEditing] = useState(undefined);
    const [open, setOpen] = useState(false);
    const [openImportExportModal, setOpenImportExportModal] = useState(false)

    return <Section title={title}>
        <Col hidden={sectorControl !== 'ALL'} xs={"auto"} className={"text-start"}>
            <Button onClick={() => setOpenImportExportModal(true)}>Import</Button>
        </Col>

        <Col className={"text-end"}>
            <Button onClick={() => setOpen(true)}>Nieuw</Button>
        </Col>

        <DataListView title={'Ledenlijst'}
                      onOpenChange={setOpen}

                      onItemEditChange={setFileEditing}
                      dataArray={membersDetailedSectorControlFiltered ? membersDetailedSectorControlFiltered : []}
                      header={[{title: "Lidnr", fieldName: "lidNr"}, {
                          title: "Sector",
                          fieldName: "sector"
                      }, {title: "Club naam", fieldName: "clubNaam"}, {
                          title: "naam",
                          fieldName: "naam"
                      }, {title: "voornaam", fieldName: "voornaam"}, {
                          title: "Categorie",
                          fieldName: "categorie"
                      }, {
                          title: "Geslacht",
                          fieldName: "geslacht"
                      }, {title: "Email", fieldName: "email"}]}
                      searchHeaders={[{title: "Lidnr", fieldName: "lidNr"}, {
                          title: "Sector",
                          fieldName: "sector"
                      }, {title: "Club naam", fieldName: "clubNaam"}, {
                          title: "naam",
                          fieldName: "naam"
                      }, {title: "voornaam", fieldName: "voornaam"}, {
                          title: "Categorie",
                          fieldName: "categorie"
                      }, {
                          title: "Geslacht",
                          fieldName: "geslacht"
                      }, {title: "Email", fieldName: "email"}, {
                          title: "Actief", fieldName: "actief", isBool: true,
                          default: true
                      }]}
        />

        <ModalPopUp open={open} onOpenChanged={setOpen}
                    modalContent={<FileOptionModalContent fileEditing={fileEditing} setFileEditing={setFileEditing}
                                                          onOpenChanged={setOpen}/>}/>
        <ModalPopUp open={openImportExportModal} onOpenChanged={setOpenImportExportModal}
                    modalContent={<ImportExportModalContent members={membersDetailedSectorControlFiltered}
                                                            onOpenChange={setOpenImportExportModal}
                                                            openImportExportModal={openImportExportModal}/>}>

        </ModalPopUp>
    </Section>
}


function ImportExportModalContent(props) {
    const {onOpenChange, members} = props
    const [data, setData] = useState(undefined);
    const {createMember, editMember} = useMemberMutations();
    const mappedDataForDb = data?.map(d => {
        return {
            nummer: d.Nr || d.nummer,
            provincie: d.Prov || d.Provincie || d.provincie,
            sectorNr: d.Nr || d.sectorNr,
            sector: d.Sector || d.sector,
            clubNr: d.Clubnr || d.clubNr,
            clubNaam: d.Clubnaam || d.clubNaam,
            lidNr: d.Lidnummer || d.lidNr,
            naam: d.Naam || d.naam,
            voornaam: d.Voornaam || d.voornaam,
            rijksRegisterNummer: d.Rijksregisternummer || d.rijksRegisterNummer,
            adres1: d.Straat || d.adres1,
            huisNr: d['Huisnr.'] || d.Huisnr || d.huisNr,
            busNr: d['Busnr.'] || d.Busnr || d.busNr,
            postCode: d.Postnummer || d.postCode,
            gemeente: d.Plaats || d.plaats || d.gemeente,
            nationaliteit: d['Nat.'] || d.nationaliteit,
            landCode: d.Landcode || d.landCode,
            geboorteDatum: d['Geb. Datum'] || d.geboorteDatum,
            geslacht: d.Geslacht || d.geslacht,
            categorie: d.Categorie || d.categorie,
            telefoon: d.Telefoon || d.telefoon,
            email: d['Email '] || d['Email'] || d.email || d.email,
            gsm: d.GSM || d.gsm,
            votasId: d.Votas || d.votasId || d['Votas ID'],
            secretaris: !!d.Secretaris || !!d.secretaris,
            voorzitter: !!d.Voorzitter || !!d.voorzitter,
            scheidsrechter: !!d.Scheidsrechter || !!d.scheidsrechter,
            actief: !!d.Actief || d.actief,
            initiator: !!d.Initiator || !!d.initiator,
            instructeurB: !!d.instructeurB || !!d.instructeurB,
            trainerB: !!d.TrainerB || !!d.trainerB,
            trainerA: !!d.TrainerA,
            opmerking: d.Opmerking || d.opmerking

        }
    });


    const membersNotYetInDbExisting = mappedDataForDb?.filter(md => members?.filter(m => m.lidNr === md.lidNr || md.lidNr === '' || md.lidNr === undefined).length === 0);
    const membersToBeOverWritten = mappedDataForDb?.filter(md => members?.filter(m => m.lidNr === md.lidNr).length > 0);

    async function handleSave(e) {
        e.preventDefault();

        // create all new members
        const resultsCreate = membersNotYetInDbExisting.map(async m => await createMember(m));
        //edit all existing members
        const memberImportWithId = membersToBeOverWritten.map(mtbo => {
            return {...mtbo, id: members.find(m => m.lidNr === mtbo.lidNr).id}
        })

        const resultsEdit = memberImportWithId.map(async miwi => await editMember(miwi));

        if (resultsCreate && resultsEdit) {
            onOpenChange(false);
        }
    }

    return <ModalContentContainer onOpenChanged={onOpenChange}>
        <FormLabel>Selecteer ledenlijst:</FormLabel>
        <Col xs={12}>
            <CSVReader
                parserOptions={{header: true}}
                onFileLoaded={(data, fileInfo) => {
                    setData(data)
                }}
            />
        </Col>
        <Col xs={12} className={"mt-2"}>
            <Button onClick={(e) => handleSave(e)}>Opslagen</Button>
        </Col>
        <h5 className={'mt-1'}>Voorbeeld van data hier onder. Je kan ook filteren in dit voorbeeld</h5>
        {membersNotYetInDbExisting ?
            <p>Aantal leden nog niet bestaand in database : {membersNotYetInDbExisting.length}</p> : ""}
        {membersToBeOverWritten ?
            <p>Aantal leden die worden overscherven/aangepast: {membersToBeOverWritten.length}</p> : ""}
        {data ? <DataListView dataArray={mappedDataForDb} header={[{title: "Lidnr", fieldName: "lidNr"}, {
            title: "Sector",
            fieldName: "sector"
        }, {title: "Club naam", fieldName: "clubNaam"}, {
            title: "naam",
            fieldName: "naam"
        }, {title: "voornaam", fieldName: "voornaam"}, {
            title: "Categorie",
            fieldName: "categorie"
        }, {
            title: "Geslacht",
            fieldName: "geslacht"
        }, {title: "Email", fieldName: "email"}]} searchHeaders={[{title: "Lidnr", fieldName: "lidNr"}, {
            title: "Sector",
            fieldName: "sector"
        }, {title: "Club naam", fieldName: "clubNaam"}, {
            title: "naam",
            fieldName: "naam"
        }, {title: "voornaam", fieldName: "voornaam"}, {
            title: "Categorie",
            fieldName: "categorie"
        }, {
            title: "Geslacht",
            fieldName: "geslacht"
        }, {title: "Email", fieldName: "email"}, {
            title: "Actief",
            fieldName: "actief",
            isBool: true
        }]}/> : ""}
    </ModalContentContainer>
}


function FileOptionModalContent(props) {
    const {fileEditing, onOpenChanged, setFileEditing} = props;
    const {sectorControl} = useAuthenticated()
console.log(sectorControl)
    const {countrycodes} = useCountryCodes();
    const {categories} = useCategories();
    const [isLoading, setIsLoading] = useState(false);
    const {provinces} = useProvinces();
    const {sexes} = useSexes();
    const {clubs} = useClubs();
    const {sectors} = useSectors();
    const isOldBirthFormat = fileEditing?.geboorteDatum ? fileEditing.geboorteDatum.includes('/') : false;
    const birthDateBeforeSave = fileEditing?.geboorteDatum ? fileEditing?.geboorteDatum : "empty";
    const sectorsSorted = sectors ? [...sectors].sort((s1, s2) => ('' + s1.sectorNaam).localeCompare('' + s2.sectorNaam)) : [];
    const clubSorted = clubs ? [...clubs].sort((c1, c2) => ('' + c1.club).localeCompare('' + c2.club)) : [];

    const {createMember, editMember, deleteMember} = useMemberMutations();
    const initialObjectInintializer = useCallback(() => fileEditing ? {...fileEditing} : {
        ...MEMBER_EMPTY
    }, [])


    const {
        tempObject,
        setTempObject,
        onChange,
        onEditorChange,
        onCheckboxChange,
    } = useForm(initialObjectInintializer)


    async function handleCreateSubmit(e) {
        e.preventDefault();

        const result = await createMember(tempObject);
        if (result) {
            onOpenChanged(false);
            setFileEditing(undefined);
        }
        setIsLoading(false);
    }

    async function handleEditSubmit(e) {
        e.preventDefault();
        const result = await editMember(tempObject);
        if (result) {
            onOpenChanged(false);
            setFileEditing(undefined);

        }
        setIsLoading(false);
    }


    return <ModalContentContainer onOpenChanged={onOpenChanged} onEditingChanged={setFileEditing}>
        <Form>
            <Section title={fileEditing ? "Wijzig lid" : "Nieuw lid"}>
                <Row>
                    <Col xs={'auto'}>
                        <LabelWithInput title={"Provincie"}><FormControl
                            value={tempObject.provincie}
                            onChange={(e) => onChange(e, 'provincie')}></FormControl></LabelWithInput>
                    </Col>
                </Row>
                <Row>
                    <Col xs={3}>
                        <LabelWithInput title={"Sectornr"}><FormControl disabled={true}
                                                                        value={tempObject.sectorNr} type={'number'}
                        ></FormControl></LabelWithInput>
                    </Col>
                    <Col xs={3}>
                        <LabelWithInput title={"Sector"}><FormSelectList value={tempObject?.sector}
                                                                         defaultValueText={'Selecteer sector'}
                                                                         dataList={sectorsSorted ? sectorsSorted?.map(s => s.sectorNaam) : []}
                                                                         onChange={e => {

                                                                             const sectorNr = sectors?.find(s => s.sectorNaam === e.target.value);
                                                                             setTempObject({
                                                                                 ...tempObject,
                                                                                 sector: e.target.value,
                                                                                 sectorNr: sectorNr?.sectorNummer ? sectorNr?.sectorNummer : ""
                                                                             })
                                                                         }}/></LabelWithInput>
                    </Col>
                    <Col xs={3}>
                        <LabelWithInput title={"Clubnummer"}><FormControl value={tempObject.clubNr}
                                                                          disabled={tempObject.clubNaam.includes('Individueel')}
                                                                          type={'number'}
                        ></FormControl></LabelWithInput>
                    </Col>
                    <Col xs={3}>
                        <LabelWithInput title={"Club"}><FormSelectList defaultValueText={'Selecteer club'}
                                                                       value={tempObject?.clubNaam}
                                                                       onChange={e => {

                                                                           const club = clubs?.find(c => c.club === e.target.value);
                                                                           setTempObject({
                                                                               ...tempObject,
                                                                               clubNaam: e.target.value,
                                                                               clubNr: club?.stamNummer ? club?.stamNummer : ""
                                                                           });
                                                                       }}
                                                                       dataList={clubSorted ? clubSorted.map(c => c.club) : []}/></LabelWithInput>
                    </Col>
                </Row>
                <Row>
                    <Col xs={3}>
                        <LabelWithInput title={"Lidnummer"}><FormControl value={tempObject.lidNr} type={'number'}
                                                                         onChange={(e) => onChange(e, 'lidNr')}></FormControl></LabelWithInput>
                    </Col>
                    <Col xs={3}>
                        <LabelWithInput title={"Naam"}><FormControl value={tempObject.naam}
                                                                    onChange={(e) => onChange(e, 'naam')}></FormControl></LabelWithInput>
                    </Col>
                    <Col xs={3}>
                        <LabelWithInput title={"Voornaam"}><FormControl value={tempObject.voornaam}
                                                                        onChange={(e) => onChange(e, 'voornaam')}></FormControl></LabelWithInput>
                    </Col>
                    <Col xs={3}>
                        <LabelWithInput title={"Rijksregnr"}><FormControl value={tempObject.rijksRegisterNummer}
                                                                          onChange={(e) => onChange(e, 'rijksRegisterNummer')}></FormControl></LabelWithInput>
                    </Col>
                </Row>
                <Row>
                    <Col xs={2}>
                        <LabelWithInput title={"Straat"}><FormControl value={tempObject.adres1}
                                                                      onChange={(e) => onChange(e, 'adres1')}></FormControl></LabelWithInput>
                    </Col>
                    <Col xs={2}>
                        <LabelWithInput title={"Huisnr"}><FormControl value={tempObject.huisNr}
                                                                      onChange={(e) => onChange(e, 'huisNr')}></FormControl></LabelWithInput>
                    </Col>
                    <Col xs={2}>
                        <LabelWithInput title={"Bus"}><FormControl value={tempObject.busNr}
                                                                   onChange={(e) => onChange(e, 'busNr')}></FormControl></LabelWithInput>
                    </Col>
                    <Col xs={2}>
                        <LabelWithInput title={"Postnr"}><FormControl value={tempObject.postCode}
                                                                      onChange={(e) => onChange(e, 'postCode')}></FormControl></LabelWithInput>
                    </Col>
                    <Col xs={2}>
                        <LabelWithInput title={"Gemeente"}><FormControl value={tempObject.gemeente}
                                                                        onChange={(e) => onChange(e, 'gemeente')}></FormControl></LabelWithInput>
                    </Col>
                    <Col xs={2}>
                        <LabelWithInput title={"Land"}><FormSelectList defaultValueText={'Selecteer land'}
                                                                       value={tempObject?.landCode}
                                                                       onChange={e => {

                                                                           setTempObject({
                                                                               ...tempObject,
                                                                               landCode: e.target.value,
                                                                           });
                                                                       }}
                                                                       dataList={countrycodes ? countrycodes.map(c => c.label) : []}/></LabelWithInput>
                    </Col>
                </Row>
                <Row>
                    <Col xs={3}>
                        {isOldBirthFormat ?
                            <div className={'rounded p-2 border border-1 border-danger'}>
                                Waarschuwing: Dit lid bevat het oude datum formaat. Gelieve de onderstaande datum
                                opnieuw in te vullen met de datum selecteer functie.
                                <LabelWithInput title={"Geboortedatum"}><FormControl
                                    value={birthDateBeforeSave}
                                    disabled={true}
                                    onChange={(e) => onChange(e, 'geboorteDatum')}
                                ></FormControl></LabelWithInput>
                                <LabelWithInput title={"Geboortedatum"}><FormControl type={'date'}
                                                                                     value={tempObject.geboorteDatum}
                                                                                     onChange={(e) => {

                                                                                         setTempObject({
                                                                                             ...tempObject,
                                                                                             geboorteDatum: e.target.value,
                                                                                             categorie: checkCategoryFromDate(e.target.value, categories)
                                                                                         })
                                                                                         console.log(tempObject)
                                                                                     }}
                                ></FormControl></LabelWithInput>
                            </div> :
                            <>
                                <LabelWithInput title={"Geboortedatum"}><FormControl type={'date'}
                                                                                     value={tempObject.geboorteDatum}
                                                                                     onChange={(e) => {

                                                                                         setTempObject({
                                                                                             ...tempObject,
                                                                                             geboorteDatum: e.target.value,
                                                                                             categorie: checkCategoryFromDate(e.target.value, categories)
                                                                                         })
                                                                                         console.log(tempObject)
                                                                                     }}
                                ></FormControl></LabelWithInput>
                            </>}

                    </Col>
                    <Col xs={'auto'}>
                        <LabelWithInput title={"Geslacht M/V/X"}><FormSelectList value={tempObject.geslacht}
                                                                                 defaultValueText={'Selecteer geslacht'}
                                                                                 dataList={sexes ? sexes?.map(s => s.title) : []}
                                                                                 onChange={e => onChange(e, 'geslacht')}/></LabelWithInput>
                    </Col>
                    <Col xs={3}>
                        <LabelWithInput title={"Categorie"}><FormControl value={tempObject.categorie}
                                                                         onChange={(e) => onChange(e, 'categorie')}></FormControl></LabelWithInput>
                    </Col>
                    <Col xs={3}>

                        <LabelWithInput title={"Nationaliteit"}><FormSelectList
                            defaultValueText={'Selecteer nationaliteit'}
                            value={tempObject?.nationaliteit}
                            onChange={e => {
                                setTempObject({
                                    ...tempObject,
                                    nationaliteit: e.target.value,
                                });
                            }}
                            dataList={countrycodes ? countrycodes.map(c => c.label) : []}/></LabelWithInput>
                    </Col>
                </Row>
                <Row>
                    <Col xs={4}>
                        <LabelWithInput title={"Telefoon"}><FormControl value={tempObject.telefoon}
                                                                        onChange={(e) => onChange(e, 'telefoon')}></FormControl></LabelWithInput>
                    </Col>
                    <Col xs={4}>
                        <LabelWithInput title={"Email"}><FormControl value={tempObject.email} type={'email'}
                                                                     onChange={(e) => onChange(e, 'email')}></FormControl></LabelWithInput>
                    </Col>
                    <Col xs={4}>
                        <LabelWithInput title={"Gsm"}><FormControl value={tempObject.gsm}
                                                                   onChange={(e) => onChange(e, 'gsm')}></FormControl></LabelWithInput>
                    </Col>
                </Row>
                <Row className={"g-0"}>
                    <Col xs={6}>

                        <Col xs={12}>
                            <LabelWithInput title={"Voorzitter"} reverse={true}><FormCheck
                                defaultChecked={!!tempObject.voorzitter}
                                onChange={(e) => onCheckboxChange(e, 'voorzitter')}></FormCheck></LabelWithInput>
                        </Col>


                        <Col xs={12}>
                            <LabelWithInput title={"Secretaris"} reverse={true}><FormCheck
                                defaultChecked={!!tempObject.secretaris}
                                onChange={(e) => onCheckboxChange(e, 'secretaris')}></FormCheck></LabelWithInput>
                        </Col>


                        <Col xs={12}>
                            <LabelWithInput title={"Scheidsrechter"} reverse={true}><FormCheck
                                defaultChecked={!!tempObject.scheidsrechter}
                                onChange={(e) => onCheckboxChange(e, 'scheidsrechter')}></FormCheck></LabelWithInput>
                        </Col>

                    </Col>
                    <Col xs={6}>

                        <Col xs={12}>
                            <LabelWithInput title={"Actief"} reverse={true}><FormCheck
                                defaultChecked={!!tempObject.actief}
                                onChange={(e) => onCheckboxChange(e, 'actief')}></FormCheck></LabelWithInput>
                        </Col>


                        <Col xs={12}>
                            <LabelWithInput title={"initiator"}
                                            reverse={true}><FormCheck
                                defaultChecked={!!tempObject.initiator}
                                onChange={(e) => onCheckboxChange(e, 'initiator')}></FormCheck></LabelWithInput>
                        </Col>
                        <Col xs={12}>
                            <LabelWithInput title={"instructeur B"}
                                            reverse={true}><FormCheck
                                defaultChecked={!!tempObject.instructeurB}
                                onChange={(e) => onCheckboxChange(e, 'instructeurB')}></FormCheck></LabelWithInput>
                        </Col>

                        <Col xs={12}>
                            <LabelWithInput title={"Trainer B"} reverse={true}><FormCheck
                                defaultChecked={!!tempObject.trainerB}
                                onChange={(e) => onCheckboxChange(e, 'trainerB')}></FormCheck></LabelWithInput>
                        </Col>


                        <Col xs={4}>
                            <LabelWithInput title={"Trainer A"} reverse={true}><FormCheck
                                defaultChecked={!!tempObject.trainerA}
                                onChange={(e) => onCheckboxChange(e, 'trainerA')}></FormCheck></LabelWithInput>
                        </Col>

                    </Col>
                </Row>


                <Row>
                    <Col xs={'auto'} className={'mt-2'}>

                        <LabelWithInput title={"Votas id:"}><FormControl
                            value={tempObject.votasId ? tempObject.votasId : ""}
                            onChange={(e) => onChange(e, 'votasId')}></FormControl></LabelWithInput>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} className={'mt-2'}>
                        <p>Opmerking</p>
                        <CustomEditor onEditorChange={onEditorChange} initText={tempObject.opmerking}
                                      fieldName={"opmerking"} disableToolbar={true} height={100}/>
                    </Col>
                </Row>

                {fileEditing ?

                    <Col xs={6} className={'mt-3'}>

                        {sectorControl === 'ALL' ? <>
                            <ButtonLoading className={"btn-danger"} title={"Delete"} isLoading={isLoading} onClick={async (event) => {
                                setIsLoading(true);
                                const deleted = await deleteMember(fileEditing);
                                setIsLoading(false);
                                setFileEditing(undefined);
                                onOpenChanged(false);
                            }}/>
                        </>:<></>}

                    </Col> : ""}
                <Col xs={fileEditing ? 6 : 12} className={"text-end mt-3"}>
                    <ButtonLoading title={"Opslaan"} isLoading={isLoading} onClick={(event) => {
                        setIsLoading(true);
                        fileEditing ? handleEditSubmit(event) : handleCreateSubmit(event)
                    }}/>
                </Col>

            </Section>
        </Form>
    </ModalContentContainer>
}






